// document.addEventListener('DOMContentLoaded', () => {
//   if (!window.matchMedia('(min-width: 990px)').matches) return;

//   document.querySelectorAll('.header__inline-menu details.mega-menu')
//     .forEach(details => {
//       const summary = details.querySelector('summary');
//       const panel = details.querySelector('.mega-menu__content');
//       let closeTimer;

//       const openMenu = () => {
//         clearTimeout(closeTimer);
//         details.setAttribute('open', '');
//       };

//       const closeMenu = () => {
//         closeTimer = setTimeout(() => {
//           details.removeAttribute('open');
//         }, 200);
//       };

//       summary.addEventListener('mouseenter', openMenu);
//       summary.addEventListener('mouseleave', closeMenu);

//       panel.addEventListener('mouseenter', openMenu);
//       panel.addEventListener('mouseleave', closeMenu);
//     });
// });


document.querySelectorAll('.mega-item').forEach(item => {
  const trigger = item.querySelector('.mega-trigger');
  const panel = item.querySelector('.mega-menu-panel');
  let timeout;

  if (!panel) return;

  const open = () => {
    clearTimeout(timeout);
    panel.classList.add('active');
  };

  const close = () => {
    timeout = setTimeout(() => {
      panel.classList.remove('active');
    }, 200);
  };

  trigger.addEventListener('mouseenter', open);
  trigger.addEventListener('mouseleave', close);
  panel.addEventListener('mouseenter', open);
  panel.addEventListener('mouseleave', close);
});

